import { FC, useState } from 'react';

import { Box, Image, ImageProps } from '@chakra-ui/react';

import OlybetLogo from '@/assets/images/olybet-logo.svg';
import { ReactComponent as SpainOlybetLogo } from '@/assets/images/spain-olybet-logo.svg';

import { IS_SPAIN_TENANT } from '@/utils/constants';

export const Logo: FC<ImageProps> = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  if (IS_SPAIN_TENANT) {
    return (
      <Box {...props}>
        <SpainOlybetLogo />
      </Box>
    );
  }

  return (
    <Image
      alt='logo'
      display={isLoaded ? 'block' : 'none'}
      onLoad={() => setIsLoaded(true)}
      src={OlybetLogo}
      {...props}
    />
  );
};
